import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import Login from '../pages/authentication/Login';
import { useIsAuthenticated } from '@azure/msal-react';
import useAuth from '../hooks/useAuth';

const NonAdminGuard = (props) => {
  const { children } = props;
  const { isAuthenticated, isSiteAdmin, isProducer } = useAuth()
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isAuthenticated) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }

    return <Login />;
  }

  if (!isSiteAdmin && !isProducer) {
    return <Navigate to='/' />;
  }

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

NonAdminGuard.propTypes = {
  children: PropTypes.node
};

export default NonAdminGuard;
